module.exports = "/images/vendor/flag-icon-css/flags/1x1/st.svg?d0a56dbbee36540ebf27ff196ea1626f";